import { Component, OnDestroy, OnInit, Input, HostListener } from '@angular/core';
import { OB } from '../../../areas/admin/full-transcript/pages/ob-report/ob.namespace';
import { takeUntil, finalize } from 'rxjs/operators';
import { Page, IUserAccount, PatientProfile, IEncounterResource } from '../../models';
import { HttpService, AppData, EncounterCommunication } from '../../services';
import { Appointment, PreviousAppointment } from '../../entities';
import { ApiResources } from '../../helpers';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { DietEncounter } from '../../models/diet-encounter.model';
import { Diet } from '../../../areas/admin/full-transcript/pages/diet-report/diet.namespace';
import { OBEncounterType } from '../../enums';

@Component({
    selector: 'diet-header',
    templateUrl: './diet-header.html',
})
export class DietHeaderWidget implements OnDestroy, OnInit {
    @Input() patientId: string;
    @Input() appointmentId: string;
    page: Page;
    isAdmission: any;
    dietEncounter: DietEncounter;
    appointments: any;
    oldAppointment: any;
    encounterCommunicationSubscription: Subscription;
    appointment: Appointment;
    patient: PatientProfile;
    husbandName: string;
    visitNumber: number;
    specialFeature: OB.SpecialFeature;
    visit: number;
    patientName: any;
    umrNo: any;
    roomName: any;
    dietvisit: Diet.DietPlanPrescribed;
    obEncounter: IEncounterResource;
    constructor(
        private readonly httpService: HttpService,
        private readonly appData: AppData,
        private readonly encounterCommunication: EncounterCommunication,
        private readonly router: Router,
    ) {
        this.page = new Page();
    }

    private findAppointment(appointmentId: string) {
        const request = {
            encryptedAppointmentId: appointmentId
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<Appointment>(ApiResources.getURI(ApiResources.appointments.base, ApiResources.appointments.findAppointment), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: Appointment) => {               
                this.appointment = response;
                this.patientName = this.appointment.patientName;
                this.umrNo = this.appointment.umrNo;
                this.roomName = this.appointment.roomName

                this.findPatientDetails();
                this.fetchAppointmentCounts();
                this.paddingTop();
            });
        this.findDashboard();
    }

    private findPatientDetails() {
        this.page.loading = true;
        this.httpService.post<PatientProfile>(ApiResources.getURI(ApiResources.patients.base, ApiResources.patients.profile), { encryptedPatientId: this.appointment.encryptedPatientId })
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: PatientProfile) => {
                if (response) {
                    this.patient = response;
                    var detaills = this.patient.relativeDetails[0];
                    if (detaills && detaills.relation == "Husband") {
                        this.husbandName = this.patient.relativeDetails[0].fullName
                    }
                }
            });
    }

    private fetchAppointmentCounts() {
        const request = {
            patientId: this.appointment.patientId
        };
        this.httpService.get<number>(ApiResources.getURI(ApiResources.dietEncounter.base, ApiResources.dietEncounter.findVisitNo), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: number) => {           
                if (response) {
                    this.visitNumber = response + 1;
                }
                this.findDashboard();
            });
        this.paddingTop();
    }

   /* private findDashboard() {
        const request = {
            encryptedAppointmentId: this.appointmentId,
            encryptedProviderId: this.page.userAccount && this.page.userAccount.encryptedReferenceId ? this.page.userAccount.encryptedReferenceId : null,
            encryptedPatientId: this.patientId,
            isAdmission: this.isAdmission
        };
        request["isAdmission"] = this.isAdmission;
        this.httpService.post<[DietEncounter, Appointment, PreviousAppointment]>(ApiResources.getURI(ApiResources.dietEncounter.base, ApiResources.dietEncounter.find), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: [DietEncounter, Appointment, PreviousAppointment]) => {
                console.log(response);
                this.dietEncounter = response["dashboard"];
                this.appointments = response["appointments"];
                this.oldAppointment = response["oldAppointment"];
                if (this.dietEncounter && this.dietEncounter.dietEncounterId) {
                    this.specialFeature = this.dietEncounter.specialFeature ? JSON.parse(this.dietEncounter.specialFeature) : null;
               
                }
                this.dietvisit = this.dietEncounter.dietPlanPrescribed ? JSON.parse(this.dietEncounter.dietPlanPrescribed) : null;
                if (this.dietvisit) {
                    this.visit = this.dietvisit && this.dietvisit.visitNo ? this.dietvisit.visitNo : this.visitNumber;
                }
                this.paddingTop();
            });
    }*/
    private findDashboard() {
        const request = { encryptedAppointmentId: this.appointmentId, isAdmission: this.isAdmission, type: OBEncounterType.SpeacialFeature };

        request["isAdmission"] = this.isAdmission;
        this.httpService.post<IEncounterResource>(ApiResources.getURI(ApiResources.gynEncounter.base, ApiResources.gynEncounter.fetchCommonEncounter), request)
            .pipe(takeUntil(this.page.unSubscribe))
            .pipe(finalize(() => this.page.loading = false))
            .subscribe((response: IEncounterResource) => {
                this.obEncounter = response;
                this.specialFeature = JSON.parse(this.obEncounter.jsonString);
               // this.dietvisit = this.dietEncounter.die ? JSON.parse(this.gynEncounter.gynaecVisit) : null;

            });
    }
    ngOnInit() {
        this.appData.userAccount
            .pipe(takeUntil(this.page.unSubscribe))
            .subscribe((userAccount: IUserAccount) => {
                if (userAccount) {
                    this.page.userAccount = userAccount;
                    const url = this.router.url;
                    this.isAdmission = url.split("/")[4] === "a";
                    this.appointmentId = url.split("/")[url.split("/").length - 3];
                    this.encounterCommunicationSubscription = this.encounterCommunication.dietEncounter.subscribe(() => {
                     
                        if (this.appointmentId == "b" || this.appointmentId == "a") {
                            this.appointmentId = url.split("/")[url.split("/").length - 4];
                        }                      
                    });
                } else {
                    this.page.userAccount = undefined;
                }
                this.findAppointment(this.appointmentId);
                this.findDashboard();
            });
    }
    @HostListener('window:resize')
    onResize() {
        this.paddingTop();
    }
    @HostListener('window:load')
    onLoad() {
        setTimeout(() => { this.paddingTop(); }, 1500)
    }
    @HostListener('window:hashchange')
    onhashchange() {
        setTimeout(() => { this.paddingTop(); }, 500)
    }
    paddingTop() {
        if (document.getElementById("header") != null && document.getElementsByClassName("content")[0] != null) {
            var paddingTopValue = document.getElementById("header").offsetHeight;
            var content = document.getElementsByClassName("content")[0];
            content.setAttribute('style', `padding-top:${paddingTopValue}px`);
        }
    }
    ngOnDestroy() {
        this.page.unsubscribeAll();
        this.page.unSubscribe.complete();
        this.encounterCommunicationSubscription.unsubscribe();
    }
  

}